import { Alert, H3, H4, Intent, UL } from '@blueprintjs/core';
import { MandatoryWorkflowField } from '../../types';
import { prettifyWorkflowField } from '../../utils';
import { useCallback } from 'react';
import { useAppDispatch } from '../../hooks';
import { previousStep } from '../../views/workflow/reducer';

interface FieldsUnfilledAlertProps {
  isOpen: boolean;
  unfilledFields: MandatoryWorkflowField[];
  onClose: () => void;
}
const FieldsUnfilledAlert = ({
  isOpen,
  unfilledFields,
  onClose,
}: FieldsUnfilledAlertProps) => {
  const dispatch = useAppDispatch();

  const handleClose = useCallback(() => {
    const hasPersonUnfilledFields =
      unfilledFields?.filter(
        (cur) => cur !== MandatoryWorkflowField.VIDEO_INPUT,
      )?.length > 0;

    if (hasPersonUnfilledFields) {
      dispatch(previousStep());
    }
    onClose();
  }, [dispatch, unfilledFields, onClose]);

  return (
    <Alert isOpen={isOpen} intent={Intent.DANGER} onClose={handleClose}>
      <H3>Atenção!</H3>
      <H4>Os seguintes campos não foram preenchidos:</H4>
      <UL>
        {unfilledFields?.map((cur, i) => (
          <li key={i}>{prettifyWorkflowField(cur)}</li>
        ))}
      </UL>
    </Alert>
  );
};

export default FieldsUnfilledAlert;
